import { io } from 'socket.io-client';

const socket = io('/', {autoConnect: false, reconnectionAttempts: 2});

export default socket;